import { useState, useEffect } from 'react';
import { client } from 'shared';

export const useSupportedStates = () => {
    const [supportedStates, setSupportedStates] = useState<string[]>([]);

    useEffect(() => {
        client('api/state/get-supported-states/').then(setSupportedStates);
    }, []);

    return supportedStates;
};
